import { render, staticRenderFns } from "./EndorsementList.vue?vue&type=template&id=76b52042&"
import script from "./EndorsementList.vue?vue&type=script&lang=js&"
export * from "./EndorsementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports